import { render, staticRenderFns } from "./ProductTableViewForm.vue?vue&type=template&id=3326da86&"
import script from "./ProductTableViewForm.vue?vue&type=script&lang=js&"
export * from "./ProductTableViewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports